import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "../../../../../style";
import { styleSizes } from "constants/styleSizes";

export const CancelGroupBookingContainer = styled(BasicSectionContainer)`
  .cardContent {
    .removeBooking {
      margin-top: 32px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      gap: 10px;
    }
    .guestsHeader {
      font-size: 24px;
      font-weight: 600;
      line-height: 24px;
      margin-bottom: 32px;
    }

    .guestsTableHeader {
      justify-items: stretch;
      width: 100%;
      display: grid;
      grid-template-columns: 355fr 355fr 438fr 200fr;
      font-size: 15px;
      font-weight: 600;
      color: ${colors.black};
      padding: 20px 0;
      border-bottom: 1px solid ${colors.black};
      border-top: 1px solid ${colors.black};
      flex: 1;

      .col {
        text-align: left;
        font-size: 15px;
        font-weight: 600;
        line-height: 21px;
        padding-right: 10px;
      }

      &.roomMode {
        grid-template-columns: 355fr 438fr 200fr;
      }

      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        display: none;
      }
    }

    .guestsTableBody {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .guestsTableContent {
      justify-items: stretch;
      width: 100%;
      display: grid;
      grid-template-columns: 355fr 355fr 438fr 200fr;
      font-size: 16px;
      font-weight: 600;
      color: ${colors.black};
      padding: 20px 0;
      border-bottom: 1px solid ${colors.black};

      &.roomMode {
       grid-template-columns: 355fr 438fr 200fr;
      }

      .col {
        text-align: left;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        padding-right: 10px;
      }

      .name {
        font-weight: 600;
      }

      .remove {
        color: ${colors.badge};
        text-decoration: underline;
        cursor: pointer;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          float: right;
        }
      }

      &:last-child {
        border-bottom: 1px solid ${colors.white};
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          border-bottom: 1px solid ${colors.accounMenuBorderColor};
        }
      }
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        grid-template-columns: 1fr;
        gap: 16px;
        border: 1px solid ${colors.accounMenuBorderColor};
        padding: 16px;
      }
    }
  }
`;
